import SegmentedDistributionBar from './SegmentedDistributionBar';

export default SegmentedDistributionBar;

export type {
  IDistributionSegment,
  ISegmentedDistributionBarProps,
  SegmentedDistributionBarHeight
} from './SegmentedDistributionBar';
